import React, { useState, useEffect } from "react";

const WhatsAppScrollButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // Show the WhatsApp button when scrolling down, hide it when at the top
      if (scrollTop > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!isVisible) {
    return null; // Don't render if not visible
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: "88px",
        right: "15px",
        zIndex: 9999,
        cursor: "pointer",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#25D366", // WhatsApp green color
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
      onClick={() => window.open("https://wa.me/+918370055955 ", "_blank")} // Replace with your WhatsApp link
    >
      <i
        className="fab fa-whatsapp"
        style={{ fontSize: "24px", color: "#fff" }}
      ></i>
    </div>
  );
};

export default WhatsAppScrollButton;
